export var LoadPresentationEvent;
(function (LoadPresentationEvent) {
    LoadPresentationEvent["Head"] = "head";
    LoadPresentationEvent["Chunk"] = "chunk";
    LoadPresentationEvent["End"] = "end";
    LoadPresentationEvent["Abort"] = "abort";
    LoadPresentationEvent["FatalError"] = "fatal-error";
    LoadPresentationEvent["CaptureError"] = "capture-error";
    LoadPresentationEvent["RequestAbort"] = "abort";
})(LoadPresentationEvent || (LoadPresentationEvent = {}));
export var LoadPresentationInternalEvent;
(function (LoadPresentationInternalEvent) {
    LoadPresentationInternalEvent["ReadCache"] = "read-cache";
})(LoadPresentationInternalEvent || (LoadPresentationInternalEvent = {}));
export var SavePresentationEvent;
(function (SavePresentationEvent) {
    SavePresentationEvent["JSONSaved"] = "json-saved";
    SavePresentationEvent["DocumentSaved"] = "document-saved";
    SavePresentationEvent["Cancel"] = "cancel";
    SavePresentationEvent["Abort"] = "abort";
    SavePresentationEvent["FatalError"] = "fatal-error";
    SavePresentationEvent["CaptureError"] = "capture-error";
})(SavePresentationEvent || (SavePresentationEvent = {}));
export var ConvertErrorType;
(function (ConvertErrorType) {
    /**
     * 成功
     */
    ConvertErrorType[ConvertErrorType["None"] = 0] = "None";
    /**
     * 文档被其他进程抢占
     */
    ConvertErrorType[ConvertErrorType["IOShareViolationError"] = 4003] = "IOShareViolationError";
    /**
     * 文档不存在或不可读
     */
    ConvertErrorType[ConvertErrorType["IONotFoundError"] = 4004] = "IONotFoundError";
    /**
     * 文档禁止读取或写入，权限不足
     */
    ConvertErrorType[ConvertErrorType["IOUnauthorizedAccessError"] = 4005] = "IOUnauthorizedAccessError";
    /**
     * 文档未知原因，无法读写
     */
    ConvertErrorType[ConvertErrorType["IOUnavailableError"] = 4006] = "IOUnavailableError";
    /**
     * 文档被加密
     */
    ConvertErrorType[ConvertErrorType["DocumentEncryptedError"] = 4001] = "DocumentEncryptedError";
    /**
     * 文档已损坏（ZipPackage）
     */
    ConvertErrorType[ConvertErrorType["DocumentBrokenPackageError"] = 4021] = "DocumentBrokenPackageError";
    /**
     * 文档已损坏（OOXML）
     */
    ConvertErrorType[ConvertErrorType["DocumentBrokenOOXMLError"] = 4022] = "DocumentBrokenOOXMLError";
    /**
     * 磁盘空间不足
     */
    ConvertErrorType[ConvertErrorType["OutOfSpaceError"] = 4013] = "OutOfSpaceError";
    /**
     * 相应的格式转换未实现，请求无效
     */
    ConvertErrorType[ConvertErrorType["MissingConverterError"] = 5000] = "MissingConverterError";
    /**
     * 系统环境不支持
     */
    ConvertErrorType[ConvertErrorType["UnsupportedSystemEnvironmentError"] = 5001] = "UnsupportedSystemEnvironmentError";
    /**
     * 网络异常，组件加载失败
     */
    ConvertErrorType[ConvertErrorType["ComponentFetchError"] = 5002] = "ComponentFetchError";
    /**
     * 权限异常，组件执行失败
     */
    ConvertErrorType[ConvertErrorType["ComponentExecuteError"] = 5003] = "ComponentExecuteError";
    /**
     * 格式转换时，抛出业务异常
     */
    ConvertErrorType[ConvertErrorType["UnexpectedFormatConvertError"] = 5004] = "UnexpectedFormatConvertError";
    /**
     * 格式转换进程意外结束
     */
    ConvertErrorType[ConvertErrorType["UnexpectedProcessKilledError"] = 5005] = "UnexpectedProcessKilledError";
    /**
     * 导入后，JSON 格式损坏
     */
    ConvertErrorType[ConvertErrorType["UnexpectedOutputFormatError"] = 5006] = "UnexpectedOutputFormatError";
    /**
     * 导入后，Web 渲染层解析失败
     */
    ConvertErrorType[ConvertErrorType["UIModelError"] = 5007] = "UIModelError";
    /**
     * 导出时，读取 JSON 文件不存在或不可读
     */
    ConvertErrorType[ConvertErrorType["UnexpectedInputIOError"] = 5008] = "UnexpectedInputIOError";
    /**
     * 导出时，读取 JSON 文件不合法
     */
    ConvertErrorType[ConvertErrorType["UnexpectedInputFormatError"] = 5009] = "UnexpectedInputFormatError";
    /**
     * 转换进程正常退出，但没有收到转换结束的标识
     */
    ConvertErrorType[ConvertErrorType["UnexpectedFormatConvertNoEndError"] = 5010] = "UnexpectedFormatConvertNoEndError";
    /**
     * 桌面端环境不支持
     */
    ConvertErrorType[ConvertErrorType["UnsupportedAppEnvironmentError"] = 5011] = "UnsupportedAppEnvironmentError";
    /**
     * 导入时，JSON 缓存无法写入
     */
    ConvertErrorType[ConvertErrorType["CacheDataIOError"] = 5012] = "CacheDataIOError";
    /**
     * 未知错误
     */
    ConvertErrorType[ConvertErrorType["UnknownError"] = 5120] = "UnknownError";
})(ConvertErrorType || (ConvertErrorType = {}));
export function createConvertError(err, defaultCode = ConvertErrorType.UnknownError) {
    var _a;
    let code = (_a = err.code) !== null && _a !== void 0 ? _a : defaultCode;
    if (!ConvertErrorType[code]) {
        // eslint-disable-next-line no-param-reassign
        code = ConvertErrorType.UnknownError;
    }
    return { name: ConvertErrorType[code], message: err.message, stack: err.stack, code };
}
//# sourceMappingURL=mega-presentation-service.protocol.js.map